const validarDocumento = (val, tipoDocumento = 'CPF') => {
    val = removeCaracteresEspeciais(val);

    switch (tipoDocumento.toUpperCase()) {
        case 'RUC':
            return validarRuc(val);
        case 'CUIT':
        case 'DNI':
        case 'CUIT/DNI':
            return validarCUIT(val);
        case 'CNPJ':
            return validarCNPJ(val);
        case 'CPF':
        default:
            return val.length === 11 ? validarCPF(val) : validarCNPJ(val);
    }
};

const validarCNPJ = cnpj => {
    cnpj = removeCaracteresEspeciais(cnpj);

    if (
        !cnpj ||
        cnpj.length !== 14 ||
        cnpj.split('').every(c => c === cnpj[0])
    ) {
        return false;
    }

    if (/^\d{14}$/.test(cnpj)) {
        return validarCNPJNumerico(cnpj);
    }

    return validarCNPJAlfanumerico(cnpj);
};

const validarCNPJNumerico = cnpj => {
    const cnpjNumeros = cnpj.split('');
    const multiplicadores1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const multiplicadores2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    const digito1 = calculaDigitoVerificador(
        cnpjNumeros.slice(0, 12),
        multiplicadores1
    );
    const digito2 = calculaDigitoVerificador(
        cnpjNumeros.slice(0, 13),
        multiplicadores2
    );

    return (
        digito1 === parseInt(cnpjNumeros[12], 10) &&
        digito2 === parseInt(cnpjNumeros[13], 10)
    );
};

const validarCNPJAlfanumerico = cnpj => {
    if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) {
        return false;
    }

    const base = cnpj.substring(0, 12);
    if (/^0+$/.test(base)) {
        return false;
    }

    const digito1 = calculaDigitoVerificadorAlfanumerico(base);
    const digito2 = calculaDigitoVerificadorAlfanumerico(base + digito1);

    return (
        digito1 === parseInt(cnpj[12], 10) &&
        digito2 === parseInt(cnpj[13], 10)
    );
};

const validarCPF = cpf => {
    if (!cpf || cpf.length !== 11 || cpf.split('').every(c => c === cpf[0])) {
        return false;
    }

    const cpfNumeros = cpf.split('');
    const digito1 = calculaDigitoVerificador(
        cpfNumeros.slice(0, 9),
        Array.from({ length: 9 }, (_, i) => 10 - i)
    );
    const digito2 = calculaDigitoVerificador(
        cpfNumeros.slice(0, 10),
        Array.from({ length: 10 }, (_, i) => 11 - i)
    );

    return (
        digito1 === parseInt(cpfNumeros[9], 10) &&
        digito2 === parseInt(cpfNumeros[10], 10)
    );
};

const validarNomePessoa = val => {
    const regex = /^[a-zA-Z]+\s[a-zA-Z]+$/;
    if (val && val.length >= 3 && regex.test(val)) {
        return true;
    }

    return false;
};

const validarRuc = ruc => {
    const digitos = String(ruc || '').replace(/\D/g, '');

    if (digitos.length < 3) {
        return false;
    }

    const base = digitos.slice(0, -1);
    const dvInformado = parseInt(digitos.slice(-1), 10);

    let soma = 0;
    let peso = 2;

    for (let i = base.length - 1; i >= 0; i--) {
        soma += parseInt(base[i], 10) * peso;
        peso++;
    }

    const resto = soma % 11;
    const dvCalculado = resto > 1 ? 11 - resto : 0;

    return dvCalculado === dvInformado;
};

const removeCaracteresEspeciais = val => val.trim().replace(/[.\-/]/g, '').toUpperCase();

const calculaDigitoVerificador = (numeros, multiplicadores) => {
    let soma = 0;
    numeros.forEach((numero, index) => {
        soma += parseInt(numero, 10) * multiplicadores[index];
    });
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
};

const PESOS_DV_CNPJ_ALFANUMERICO = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const calculaDigitoVerificadorAlfanumerico = cnpj => {
    let soma = 0;
    for (let indice = cnpj.length - 1; indice >= 0; indice--) {
        const valorCaracter = cnpj.charCodeAt(indice) - 48;
        soma += valorCaracter * PESOS_DV_CNPJ_ALFANUMERICO[PESOS_DV_CNPJ_ALFANUMERICO.length - cnpj.length + indice];
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
};

const validarEmail = val => {
    var re = /\S+@\S+\.\S+/;
    return re.test(val);
};

const validarCUIT = cuitRaw => {
    const cuit = cuitRaw.replace(/\D/g, '');
    if (!/^\d{11}$/.test(cuit)) return false;

    const pesos = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cuit[i], 10) * pesos[i];
    }
    const resto = soma % 11;
    const dvEsperado =
      resto === 0 ? 0
    : resto === 1 ? 9
    : 11 - resto;

    return dvEsperado === parseInt(cuit[10], 10);
};

export default {
    validarDocumento,
    validarCPF,
    validarCNPJ,
    validarRuc,
    validarCUIT,
    validarNomePessoa,
    validarEmail
};
